import { render, staticRenderFns } from "./Currencies.vue?vue&type=template&id=7bc2b866&scoped=true"
import script from "./Currencies.vue?vue&type=script&lang=ts"
export * from "./Currencies.vue?vue&type=script&lang=ts"
import style0 from "./Currencies.vue?vue&type=style&index=0&id=7bc2b866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc2b866",
  null
  
)

export default component.exports